<div class="container-fluid leave-fixed-viewport">
  <div class="card leave-dashboard-card">

    <!-- Card Header -->
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-4 pe-md-0">
          <div class="header-title">
            <h2 class="mb-0">Leave Requests</h2>
            <p class="subtitle mb-0">Manage and review employee leave applications</p>
          </div>
        </div>

        <div class="col-md-8 ps-md-0">
          <div class="filter-controls-wrapper">
            <div class="row filter-row align-items-end">

              <!-- Leave Type -->
              <div class="col-12 col-md-2 filter-item">
                <label class="form-label">Leave Type</label>
                <ng-select [items]="leaveTypeOptions" bindLabel="label" bindValue="value" placeholder="All Types"
                  [(ngModel)]="filterLeaveType">
                </ng-select>
              </div>

              <!-- From Date -->
              <div class="col-12 col-md-2 filter-item">
                <label class="form-label">From Date</label>
                <input type="date" class="form-control leave-date-input" [(ngModel)]="filterFromDate">
              </div>

              <!-- To Date -->
              <div class="col-12 col-md-2 filter-item">
                <label class="form-label">To Date</label>
                <input type="date" class="form-control leave-date-input" [(ngModel)]="filterToDate">
              </div>

              <!-- Employee -->
              <div class="col-12 col-md-3 filter-item">
                <label class="form-label">Employee</label>
                <ng-select [items]="employeeDropdown" bindLabel="employee_name" bindValue="employee_id"
                  placeholder="All Employees" [(ngModel)]="filterEmployeeId">
                </ng-select>
              </div>

              <!-- Apply Button -->
              <div class="col-12 col-md-3 filter-item d-flex align-items-end">
                <button class="btn-apply-filter" (click)="applyFilters()">
                  <i class="fas fa-search me-1"></i> Apply
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loaderShown" class="leave-loading-container">
      <div class="leave-custom-loader">
        <div class="leave-loader-emblem-container">
          <img src="assets/img/logo.png" alt="Company Logo" class="leave-loader-emblem" />
          <div class="leave-loading-circle"></div>
        </div>
        <p class="leave-loading-text">Loading leave requests...</p>
      </div>
    </div>

    <!-- Card Body -->
    <div class="card-body leave-scrollable-content" *ngIf="tableShown">

      <!-- Stat Cards — click to filter by status -->
      <div class="summary-stats mb-4">
        <div class="row flex-nowrap">

          <!-- Pending -->
          <div class="col">
            <div class="stat-card stat-pending" [class.stat-active]="filterStatus === 'Pending'"
              (click)="setStatusFilter('Pending')" title="Click to filter Pending">
              <div class="stat-value">{{ pendingCount }}</div>
              <div class="stat-label">
                <i class="fas fa-clock me-1"></i> Pending
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [style.width.%]="(pendingCount / totalCount) * 100 || 0">
                </div>
              </div>
            </div>
          </div>

          <!-- Approved -->
          <div class="col">
            <div class="stat-card stat-approved" [class.stat-active]="filterStatus === 'Approved'"
              (click)="setStatusFilter('Approved')" title="Click to filter Approved">
              <div class="stat-value">{{ approvedCount }}</div>
              <div class="stat-label">
                <i class="fas fa-check-circle me-1"></i> Approved
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [style.width.%]="(approvedCount / totalCount) * 100 || 0">
                </div>
              </div>
            </div>
          </div>

          <!-- Rejected -->
          <div class="col">
            <div class="stat-card stat-rejected" [class.stat-active]="filterStatus === 'Rejected'"
              (click)="setStatusFilter('Rejected')" title="Click to filter Rejected">
              <div class="stat-value">{{ rejectedCount }}</div>
              <div class="stat-label">
                <i class="fas fa-times-circle me-1"></i> Rejected
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [style.width.%]="(rejectedCount / totalCount) * 100 || 0">
                </div>
              </div>
            </div>
          </div>

          <!-- Pre approved -->
          <div class="col">
            <div class="stat-card stat-preapproved" [class.stat-active]="filterStatus === 'Pre approved'"
              (click)="setStatusFilter('Pre approved')" title="Click to filter Pre approved">
              <div class="stat-value">{{ preApprovedCount }}</div>
              <div class="stat-label">
                <i class="fas fa-thumbs-up me-1"></i> Pre approved
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [style.width.%]="(preApprovedCount / totalCount) * 100 || 0">
                </div>
              </div>
            </div>
          </div>

          <!-- All / Total -->
          <div class="col">
            <div class="stat-card stat-total" [class.stat-active]="filterStatus === ''" (click)="setStatusFilter('')"
              title="Click to show all">
              <div class="stat-value">{{ totalCount }}</div>
              <div class="stat-label">
                <i class="fas fa-list me-1"></i> All Requests
              </div>
              <div class="stat-progress">
                <div class="progress-bar" style="width:100%"></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Bulk Approve -->
      <div class="mb-3" *ngIf="filterStatus === 'Pending' && selectedRequests.size > 0">
        <button class="btn-bulk-approve" (click)="approveSelected()">
          <i class="fas fa-check-circle me-2"></i>
          Approve Selected ({{ selectedRequests.size }})
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="output.length === 0" class="leave-empty-state">
        <i class="fas fa-calendar-times"></i>
        <p>No leave requests found</p>
        <small>Try selecting a different filter</small>
      </div>

      <!-- Table -->
      <div class="table-wrapper-frozen" *ngIf="output.length > 0">
        <table class="table leave-table">
          <thead>
            <tr>
              <th style="width:44px"></th>
              <th>Employee Name</th>
              <th>Leave Type</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
              <th>Reason</th>
              <th>Approved / Rejected By</th>
              <th>Status</th>
              <th *ngIf="hasPendingRows">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of output" [class.row-selected]="isSelected(c._id)" (click)="onRowClick(c)"
              class="clickable-row">

              <td (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isSelected(c._id)" (change)="toggleSelection(c._id, $event)"
                  [class.cb-disabled]="c.status !== 'Pending'">
              </td>

              <td>
                <div class="emp-name">{{ c.employee_name }}</div>
                <div class="emp-dept">{{ c.department_name || '—' }}</div>
              </td>

              <td>
                <span class="type-badge" [ngClass]="getLeaveTypeBadge(c.leave_type)">
                  {{ c.leave_type || '—' }}
                </span>
                <span *ngIf="c.is_marriage_leave" class="type-badge type-badge--marriage d-block mt-1">
                  <i class="fas fa-ring"></i> Marriage
                </span>
              </td>

              <td>{{ DateFormat(c.from_date) }}</td>
              <td>{{ DateFormat(c.to_date) }}</td>

              <td>
                <span class="days-pill">{{ calcDays(c.from_date, c.to_date) }}</span>
              </td>

              <td style="max-width:160px;">
                <div class="reason-cell">
                  <span class="reason-truncated">{{ c.reason || '—' }}</span>
                  <div class="reason-tooltip" *ngIf="c.reason">{{ c.reason }}</div>
                </div>
              </td>

              <td>{{ c.approved_by?.employee_name || '—' }}</td>

              <td>
                <span *ngIf="c.status" class="status-badge" [ngClass]="getStatusBadge(c.status)">
                  <i class="fas" [ngClass]="getStatusIcon(c.status)"></i>
                  {{ c.status }}
                </span>
              </td>

              <td *ngIf="hasPendingRows" class="action-cell" (click)="$event.stopPropagation()">

                <!-- Pending: Pre Approve + Approve + Reject -->
                <ng-container *ngIf="c.status === 'Pending'">
                  <button class="btn-preapprove" (click)="preApprove(c)">
                    <i class="fas fa-thumbs-up"></i> Pre Approve
                  </button>
                  <button class="btn-approve mt-1" (click)="approve(c)">
                    <i class="fas fa-check"></i> Approve
                  </button>
                  <button class="btn-reject mt-1" (click)="reject(c)">
                    <i class="fas fa-times"></i> Reject
                  </button>
                </ng-container>

                <!-- Pre Approved: Approve + Reject -->
                <ng-container *ngIf="c.status === 'Pre approved'">
                  <button class="btn-approve" (click)="approve(c)">
                    <i class="fas fa-check"></i> Approve
                  </button>
                  <button class="btn-reject mt-1" (click)="reject(c)">
                    <i class="fas fa-times"></i> Reject
                  </button>
                </ng-container>

              </td>

            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<!-- Pagination -->
<div class="row align-items-center mt-3" *ngIf="tableShown">

  <div class="col-6">
    <div class="d-flex align-items-center gap-2">
      <label class="default_font_style mb-0">Rows per page:</label>
      <select class="form-select" style="width: auto;" (ngModelChange)="limitChange($event)" [(ngModel)]="limit">
        <option *ngFor="let item of pagenumber" [ngValue]="item.value">{{ item.viewValue }}</option>
      </select>
    </div>
  </div>

  <div class="col-6 d-flex justify-content-end">
    <span style="display:none">
      <ng-container
        *ngFor="let c of output | paginate: { itemsPerPage: limit, currentPage: New_count + 1, totalItems: totalCount }">
      </ng-container>
    </span>
    <pagination-controls previousLabel="" nextLabel="" class="my-pagination" (pageChange)="onPageChange($event)">
    </pagination-controls>
  </div>

</div>